export default {
  downtimeUrl: "https://pl.kodland.com",
  startPage: {
    image: "/welcome/quiz_student_with_parent.jpeg",
    title: "Kursy kodowania online dla dzieci 8-17 lat",
    subtitle:
      "Zapisz się na darmową lekcję Python lub Scratch. Tworzymy gry, strony internetowe i kreskówki! Wyprobuj darmową lekcję!",
    button: "Zaczynajmy 🚀",
  },
  successPage: {
    title: "Wybierz datę i godzinę, aby otrzymać lekcję ZA DARMO",
    subtitle: "Kliknij przycisk “📆 Zarezerwować lekcję“, aby dokończyć rejestrację.",
    button: "📆 Zarezerwować lekcję",
  },
  quizRotateBySteps: {
    1: {
      question: "Czy masz komputer/laptop służący do nauki?",
      answers: ["👍 Tak", "😕 Nie"],
    },
    2: {
      question: "Czym zainteresowało by się Twoje dziecko?",
      answers: [
        "🌐Projektowanie stron internetowych",
        "🎮 Projektowanie gier",
        "🎨 Projektowanie grafiki",
        "🤖Roblox",
        "🤔 Inne",
        "🖼 Sztuka cyfrowa",
      ],
    },
    3: {
      question: "Jaki jest ulubiony przedmiot Twojego dziecka w szkole?",
      answers: [
        "🔬 Nauki ścisłe",
        "🎨 Sztuka i projektowanie",
        "💻 Informatyka",
        "🏛 Historia, literatura",
        "🗣 Języki obce",
        "📐 Matematyka",
        "👍 Lubi wszystkie przedmioty",
        "🤔 Nie jestem pewien/pewna",
      ],
    },
    4: {
      question: "Czy Twoje dziecko posiada jakieś umiejętności komputerowe?",
      answers: [
        "👍 Tak, lubi grać w gry komputerowe (roblox, minecraft)",
        "🙌 Tak, word/power point",
        "💻 Tak, podstawowe umiejętności",
        "🙂 Nie",
      ],
    },
  },
};
